export const GET_DATA = "GET_DATA";
export const SET_NAME = "SET_NAME";
export const SET_USER = "SET_USER";
export const SET_TOKEN = "SET_TOKEN";
export const SET_USER_LOADING = "SET_USER_LOADING";
export const LOGOUT_USER = "LOGOUT_USER";
export const NAVBAR_COLLAPSED = "NAVBAR_COLLAPSED";
